import { BusinessManagerService, businessManagerService } from './business-manager/business-manager';
import { SitePagesService, sitePagesService } from './site-pages/site-pages-service';
import {
  ComponentSettingsService,
  componentSettingsService,
} from './component-settings-service/component-settings-service';
import { SiteSettingsService, siteSettingsService } from './site-settings-service/site-settings-service';
import { GetAppDataService, getAppDataService } from '@src/sevices/get-app-data/get-app-data';

export interface IServices
  extends BusinessManagerService,
    SitePagesService,
    ComponentSettingsService,
    SiteSettingsService,
    GetAppDataService {}

export function initializeServices(): IServices {
  return {
    ...businessManagerService,
    ...sitePagesService,
    ...componentSettingsService,
    ...siteSettingsService,
    ...getAppDataService,
  };
}
